"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("./TextContainer.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var TextContainer = /*#__PURE__*/function (_Component) {
  _inherits(TextContainer, _Component);
  var _super = _createSuper(TextContainer);
  function TextContainer(props) {
    var _this;
    _classCallCheck(this, TextContainer);
    _this = _super.call(this, props);
    _this.processEditClick = _this.processEditClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  // Functions used by Editing Mode
  _createClass(TextContainer, [{
    key: "processEditClick",
    value: function processEditClick(value, event) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof this.props.triggerEditFunc !== "undefined" && this.props.isEditMode) {
        this.props.triggerEditFunc(value);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        layout = _this$props.layout,
        className = _this$props.className,
        text = _this$props.text,
        elementID = _this$props.elementID,
        textBoxStyle = _this$props.textBoxStyle,
        stylesString = _this$props.stylesString,
        styles = _this$props.styles,
        isEditMode = _this$props.isEditMode,
        assetFit = _this$props.assetFit,
        isActiveEditingElement = _this$props.isActiveEditingElement,
        textRef = _this$props.textRef,
        classes = _this$props.classes,
        style = _this$props.style,
        shadow = _this$props.shadow,
        buildInAnimation = _this$props.buildInAnimation,
        buildInAnimationSpeed = _this$props.buildInAnimationSpeed,
        buildInAnimationDelay = _this$props.buildInAnimationDelay;

      // Custom classes that will be added to the Text Container if they're defined
      var customClasses = classes || "";
      customClasses += style ? " block-0".concat(style) : "";
      customClasses += buildInAnimation ? " animate ".concat(buildInAnimation, " ").concat(buildInAnimationSpeed, " ").concat(buildInAnimationDelay) : "";
      customClasses += shadow ? " ".concat(shadow) : "";
      if (isEditMode) {
        // NOTE: NOT sure how languages fit into this....
        // DONT think this is still needed handled i a global function
        // let stylesString = "";
        // if (this.props.styles) {
        //   _map(this.props.styles, (style, key) => {
        //     let parsedKey = key.replace(/\*/g, ".");
        //     let result = "";
        //     _map(style, (value, key) => {
        //       result += key + ":" + value + ";";
        //     });
        //     stylesString +=
        //       " ." + elementID + " " + parsedKey + " {" + result + "}";
        //   });
        // }
        // we want to set the ref on the top most element, the one that will be a direct child of column
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "sc-module text ".concat(customClasses)
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "".concat(className, " ").concat(layout, " edit-mode ").concat(isActiveEditingElement ? "active-editing" : "", " ").concat(!this.props || !text ? "edit-empty" : ""),
          style: this.props ? textBoxStyle : null
          // onClick={event => {
          //   this.processEditClick(elementID, event);
          // }}
          ,
          ref: textRef
        }, stylesString ? /*#__PURE__*/_react["default"].createElement("style", {
          dangerouslySetInnerHTML: {
            __html: stylesString
          }
        }) : null, this.props ? /*#__PURE__*/_react["default"].createElement("div", {
          className: "".concat(elementID, " inner-wrapper"),
          dangerouslySetInnerHTML: {
            __html: text || ""
          },
          style: styles
        }) : null), /*#__PURE__*/_react["default"].createElement("div", {
          className: "sc-edit sc-edit-module",
          onClick: function onClick(event) {
            _this2.processEditClick(elementID, event);
          }
        }, !this.props || !text ? /*#__PURE__*/_react["default"].createElement("div", {
          className: "empty-selector"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "click-to-edit-container"
        }, /*#__PURE__*/_react["default"].createElement("h3", null, "Click to Edit"))) : null));
      } else if (text) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "sc-module text ".concat(customClasses)
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "".concat(className || ""),
          style: styles,
          dangerouslySetInnerHTML: {
            __html: text || ""
          },
          ref: textRef
        }));
      } else {
        return null; //no html needed if no text
      }
    }
  }]);
  return TextContainer;
}(_react.Component);
var _default = TextContainer;
exports["default"] = _default;